module.exports = __webpack_public_path__ + "img/inactive-icon.4098dc07.svg";